/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable hubspot-dev/no-confusing-browser-globals */
'use es6';

import { useMemo, useEffect, useState, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { debounce, throttle } from 'underscore';
import { getSortedProductConfigurations } from 'pricing-pages-lib/utils/productConfigUtils';
import { productDataSelector } from '../selectors/SelectorUtils';
export const useDebouncedFunc = (func, wait = 0, deps = []) => {
  return useMemo(() => debounce(func, wait), deps);
};
export const useThrottledFunc = (func, wait = 0, deps = []) => useMemo(() => throttle(func, wait), deps); // A hook for updating the browser URL, debounced to prevent security warnings from browsers

export const useHistoryUrlEffect = url => {
  const debounced = useDebouncedFunc(newURL => {
    history.replaceState(history.state, '', newURL);
  }, 300);
  useEffect(() => {
    debounced(url);
  }, [url]);
};
export const useIsElementAtTopOfViewport = (viewportStartY = 0) => {
  const elementRef = useRef(null);
  const [isAtTopOfViewport, setIsAtTopOfViewport] = useState(false);
  let setInitial = false;
  useEffect(() => {
    const {
      top: initialTop,
      height: initialHeight
    } = elementRef.current && elementRef.current.getBoundingClientRect() || {};

    if (initialTop && initialHeight && !setInitial) {
      setIsAtTopOfViewport(initialTop <= viewportStartY + 200 && initialTop >= viewportStartY - initialHeight);
      setInitial = true;
    }

    const onScroll = throttle(() => {
      const {
        top,
        height
      } = elementRef.current.getBoundingClientRect();
      setIsAtTopOfViewport(top <= viewportStartY + 200 && top >= viewportStartY - height);
    }, 300);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [elementRef]);
  return [elementRef, isAtTopOfViewport];
}; // Since elements aren't rendered in time for anchor links to work,
// we need to manually scroll to any anchor links on page load

export const useAnchorLinkScroll = () => {
  const hash = useRef(window.location.hash);
  useEffect(() => {
    if (hash.current && !hash.current.includes('?')) {
      document.querySelector(hash.current).scrollIntoView();
    }
  }, []);
};
export const useSortedProductConfigurations = (initialProductConfigurations = []) => {
  const productData = useSelector(productDataSelector);
  const [productConfigurations, setProductConfigurations] = useState(getSortedProductConfigurations({
    productData
  }, {
    productConfigurations: initialProductConfigurations
  }));
  const sortedSetProductConfigurations = useCallback(arg => {
    if (typeof arg === 'function') {
      // More context on why we need a setTimeout here https://git.hubteam.com/HubSpot/pricing-pages-unified-ui/pull/4990
      setTimeout(() => setProductConfigurations(prevConfigurations => getSortedProductConfigurations({
        productData
      }, {
        productConfigurations: arg(prevConfigurations)
      })), 0);
    } else {
      setTimeout(() => setProductConfigurations(getSortedProductConfigurations({
        productData
      }, {
        productConfigurations: arg
      })), 0);
    }
  }, [productConfigurations, setProductConfigurations, productData]);
  return [productConfigurations, sortedSetProductConfigurations];
};